import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const LogoutIcon = (props: IconProps) => {
    return (
		<Icon {...props}>
			<svg viewBox="0 -960 960 960" >
				<g fill="currentColor">
					<path d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h299v60H180v600h299v60H180Zm486-185-43-43 102-102H360v-60h363L621-612l43-43 176 176-174 174Z"/>
				</g>
			</svg>
		</Icon>
    )
}

export default LogoutIcon;